import { Knowledge } from "src/models/knowledge";
import { createEntityModel } from "src/store/models/entity/_shared";

export const KnowledgeEntityModel = createEntityModel<Knowledge>();
